import{useLocalizationContext as o}from"../internals/hooks/useUtils.js";const s=()=>o().localeText;export{s as usePickersTranslations};
//# sourceMappingURL=usePickersTranslations.js.map
